import { RED_LABEL_NL, WHITE_LABEL_NL } from './wines'

export const PRICE_FILTER = {
  NAME: 'Prijs',
  GET_PARAM: {
    min: 'prijs-min',
    max: 'prijs-max'
  },
  OPTIONS: [
    0, 1.0, 1.5, 2.0, 2.5, 3.0, 4.0, 5.0, 5.5, 6.5, 7.0, 8.0, 8.5, 9.0, 9.5, 10.0, 10.5, 11.0, 12.0, 12.5,
    13.0, 14.0, 15.0, 15.5, 16.5, 17.5, 18.5, 19.0, 20.0, 22.0, 23.0, 25.0, 26.5, 29.0, 30.0, 32.5, 35.0,
    38.0, 40.0, 43.0, 46.0, 48.5, 52.5, 57.5, 62.0, 69.0, 76.5, 88.5, 109.0, 149.0, 275.0
  ],
  MAX: 1000000
}

export const TASTE_PROFILE_FILTER = {
  NAME: 'Jouw Smaak',
  GET_PARAM: 'wijn',
  OPTIONS: [RED_LABEL_NL, WHITE_LABEL_NL]
}

export const ORDER_BY_FILTER = {
  GET_PARAM: 'sorteer-op',
  NAME: 'Sorteer op',
  OPTIONS: [
    { value: 'tasteProfileMatch', label: 'Smaakprofiel Match', selected: true },
    { value: 'popularity', label: 'Populariteit', selected: false },
    { value: 'priceAscending', label: 'Prijs oplopend', selected: false },
    { value: 'priceDescending', label: 'Prijs aflopend', selected: false },
    { value: 'name', label: 'Naam', selected: false }
  ]
}

export const COUNTRY_FILTER = {
  GET_PARAM: 'land',
  NAME: 'Land',
  JOIN_MULTIPLE_ON: '-of-',
  OPTIONS: [
    { value: 'frankrijk', label: 'Frankrijk', selected: false },
    { value: 'chili', label: 'Chili', selected: false },
    { value: 'zuid-afrika', label: 'Zuid-Afrika', selected: false },
    { value: 'argentinie', label: 'Argentinië', selected: false },
    { value: 'italie', label: 'Italië', selected: false },
    { value: 'nw-zeeland', label: 'Nieuw-Zeeland', selected: false },
    { value: 'portugal', label: 'Portugal', selected: false },
    { value: 'spanje', label: 'Spanje', selected: false },
    { value: 'australie', label: 'Australië', selected: false },
    { value: 'duitsland', label: 'Duitsland', selected: false },
    { value: 'griekenland', label: 'Griekenland', selected: false },
    { value: 'oostenrijk', label: 'Oostenrijk', selected: false },
    { value: 'verenigde-staten', label: 'Verenigde-Staten', selected: false },
    { value: 'brazilie', label: 'Brazilië', selected: false },
    { value: 'nederland', label: 'Nederland', selected: false },
    { value: 'romenie', label: 'Romenië', selected: false },
    { value: 'hongarije', label: 'Hongarije', selected: false },
    { value: 'kroatie', label: 'Kroatië', selected: false },
    { value: 'slovenie', label: 'Slovenië', selected: false },
    { value: 'turkije', label: 'Turkije', selected: false },
    { value: 'zwitserland', label: 'Zwitserland', selected: false }
  ]
}

export const FILTER_NAME_MAP = {
  [TASTE_PROFILE_FILTER.NAME]: TASTE_PROFILE_FILTER.GET_PARAM,
  [ORDER_BY_FILTER.NAME]: ORDER_BY_FILTER.GET_PARAM,
  [PRICE_FILTER.NAME]: PRICE_FILTER.GET_PARAM,
  [COUNTRY_FILTER.NAME]: COUNTRY_FILTER.GET_PARAM
}

export const FILTER_DISPLAY_TYPES = {
  range: 'range',
  select: 'select',
  radio: 'radio',
  checkbox: 'checkbox'
}
